'use client'

import cleanStoredInfo from '@/useCases/auth/cleanStoredInfo'

const handleLogout = async () => {
  await cleanStoredInfo()
  await new Promise((resolve) => setTimeout(resolve, 500)) // Wait for Apollo logOut to complete
  return true
}

export default handleLogout
